var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.980804,
    y: 0.25,
    width: 21.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_2504",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.980804,
    y: 0.25,
    width: 21.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_2504)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4451 2.66667C16.7308 2.5212 17.0244 2.84858 16.8487 3.11683L16.498 3.65249C16.4631 3.70586 16.4179 3.75178 16.3651 3.7876L14.9285 4.7628C14.892 4.78754 14.8581 4.81583 14.8272 4.84726L14.8086 4.86619C14.5539 5.12554 14.5539 5.54113 14.8086 5.80047L14.9387 5.93286C15.1934 6.19221 15.1934 6.60779 14.9387 6.86714L14.6923 7.11794C14.4885 7.32552 14.1696 7.37492 13.9104 7.24293V7.24293C13.5789 7.07418 13.1681 7.20656 13.0041 7.54043L12.9004 7.75153C12.8223 7.91059 12.6841 8.03201 12.5163 8.08897L11.3112 8.49796C11.2422 8.52139 11.1698 8.53333 11.0969 8.53333H10.5747C10.3205 8.53333 10.0884 8.67793 9.9763 8.90614L9.93369 8.9929C9.76974 9.32677 9.3643 9.4619 9.03283 9.29315L7.63727 8.58269C7.57307 8.55 7.51458 8.50712 7.4641 8.45572L6.68374 7.66117C6.56131 7.53651 6.49271 7.36877 6.49271 7.19404V6.76901C6.49271 6.56521 6.65792 6.4 6.86172 6.4V6.4C6.96074 6.4 7.0556 6.3602 7.12499 6.28956L7.86817 5.53286C7.99352 5.40523 8.16491 5.33333 8.3438 5.33333H8.62852C8.9168 5.33333 9.17241 5.14805 9.2621 4.87409L9.45081 4.29766C9.55612 3.97599 9.88576 3.78428 10.2174 3.85182L12.105 4.23621C12.2035 4.25626 12.3052 4.2538 12.4025 4.22902L14.278 3.75163C14.3257 3.73947 14.372 3.72205 14.416 3.69968L15.3975 3.2L16.4451 2.66667V2.66667Z",
    fill: "#E7832C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7308 12.8C12.0201 12.8 12.2546 12.5612 12.2546 12.2667C12.2546 11.9721 12.0201 11.7333 11.7308 11.7333C11.4415 11.7333 11.207 11.9721 11.207 12.2667C11.207 12.5612 11.4415 12.8 11.7308 12.8Z",
    fill: "#445128"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M13.3022 11.7333C13.3022 11.7333 14.8737 11.2 15.3975 10.1333",
    stroke: "#445128",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M10.1594 11.7333C10.1594 11.7333 8.58795 11.2 8.06414 10.1333",
    stroke: "#445128",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCy);
export default __webpack_public_path__ + "static/media/cy.0d685f70b4ee2adac582a8d9f49f3fd9.svg";
export { ForwardRef as ReactComponent };